import React from 'react';
import { Container, Text, Title } from '@mantine/core';


export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true });

    if ((typeof window !== 'undefined') && window.Sentry) {
      window.Sentry.configureScope((scope) => {
        Object.keys(errorInfo).forEach((key) => {
          scope.setExtra(key, errorInfo[key]);
        });
      });
      window.Sentry.captureException(error);
    }
  }

  render() {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <Container>
          <Title order={1}>Errore</Title>
          <div>
            <Text component="p">&Egrave; stato riscontrato un errore. Assicurati di:</Text>
            <ul>
              <li>Essere connesso ad internet</li>
              <li>Utilizzare un browser supportato quale:
                <ul>
                  <li><a rel="noopener noreferrer" href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Mozilla Firefox</a></li>
                  <li><a rel="noopener noreferrer" href="https://www.google.com/chrome/" target="_blank">Google Chrome</a></li>
                  <li><a rel="noopener noreferrer" href="https://www.apple.com/it/safari/" target="_blank">Apple Safari</a></li>
                  <li><a rel="noopener noreferrer" href="https://www.microsoft.com/it-it/windows/microsoft-edge" target="_blank">Microsoft Edge</a></li>
                </ul>
              </li>
              <li>Utilizzare un sistema operativo aggiornato e supportato</li>
            </ul>
            <p>Prova a ricaricare la pagina</p>
          </div>
        </Container>
      );
    }
    return this.props.children;
  }
}
